import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Se as variáveis não estiverem configuradas, NÃO lançamos erro aqui.
 * Um throw no topo do módulo aborta a carga inteira e a pessoa fica
 * olhando para uma tela em branco, com a explicação escondida no
 * console. Quem trata isso é o main.js, que mostra o aviso na tela.
 */
export const configuracaoFaltando = !url || !anonKey;

export const supabase = createClient(
  url || 'https://configuracao-ausente.invalid',
  anonKey || 'configuracao-ausente',
  { auth: { persistSession: true, autoRefreshToken: true } }
);

/**
 * Envolve uma chamada do Supabase, lançando erro com mensagem legível.
 * Uso: const empresas = await q(supabase.from('empresas').select('*'));
 */
export async function q(promise) {
  const { data, error } = await promise;
  if (error) throw new Error(error.message);
  return data;
}

/** Primeiro dia do mês, no formato que o Postgres espera (competência). */
export function competencia(ano, mes) {
  return `${ano}-${String(mes).padStart(2, '0')}-01`;
}

/** '2026-08-01' -> 'Agosto/2026' */
const MESES_EXTENSO = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];
export function competenciaExtenso(iso) {
  if (!iso) return '—';
  const [ano, mes] = iso.split('-');
  return `${MESES_EXTENSO[Number(mes) - 1]}/${ano}`;
}

/** '2026-08-01' -> 'Ago' (cabeçalho da matriz de documentos) */
export function competenciaCurta(iso) {
  if (!iso) return '—';
  const [, mes] = iso.split('-');
  return MESES_EXTENSO[Number(mes) - 1].slice(0, 3);
}
